import { ConfigurationService } from '../../../../services/configuration.service';
import type IPressRelease from '../../../../models/press/press-release.model';
import PressHelper from '../../helpers/press-helper';

function PressRelease({ pressRelease }: { pressRelease: IPressRelease }) {
  function getPressReleaseDetailsUrl() {
    const baseUrl = ConfigurationService.get('presspage.pressrelease.baseurl');
    return baseUrl ? `${baseUrl}${pressRelease.id}/` : undefined;
  }

  function hasImage() {
    return !!pressRelease.mainImage?.url;
  }

  function getImageUrlSm() {
    return PressHelper.addSizePropertiesToImageUrl(pressRelease.mainImage?.url, PressHelper.defaultImageSizeCropSm);
  }

  function getImageUrlMd() {
    return PressHelper.addSizePropertiesToImageUrl(pressRelease.mainImage?.url, PressHelper.defaultImageSizeCropMd);
  }

  function getImageUrlLg() {
    return PressHelper.addSizePropertiesToImageUrl(pressRelease.mainImage?.url, PressHelper.defaultImageSizeCropLg);
  }

  function getPublishedDate() {
    return pressRelease.published.toFormat('yyyy-MM-dd HH:mm');
  }

  return (
    <a href={getPressReleaseDetailsUrl()} className="d-block text-decoration-none">
      {hasImage() && (
        <picture>
          <source sizes="(min-width:992px) 350px, (min-width:576px) 300px, 545px" srcSet={`${getImageUrlMd()} 300w, ${getImageUrlLg()} 350w, ${getImageUrlSm()} 545w`} />
          <img src={getImageUrlLg()} alt="" className="mb-2 w-100" />
        </picture>
      )}
      <h3 className="text-decoration-underline">{pressRelease.title}</h3>
      <div className="mb-1">{getPublishedDate()}</div>
      <div>{pressRelease.leadText}</div>
    </a>
  );
}

export default PressRelease;
